import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import type { DataSource } from '../api/data-source';
import type { AuthStore } from '../auth/auth-store';
import { NotFound } from '../shell/NotFound';
import { PersonAppearance } from '../shell/PersonAppearance';
import { HelpHost } from '../screens/help/HelpHost';

/** What every route's `beforeLoad` and `loader` can reach: the session store, the data source, the Query cache. */
export interface RouterContext {
  auth: AuthStore;
  ds: DataSource;
  queryClient: QueryClient;
}

/** Every screen, and beside them the person's own look of Paige (accent, tooltips) and Help's sheets. */
function Root() {
  return (
    <>
      <Outlet />
      <PersonAppearance />
      <HelpHost />
    </>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  notFoundComponent: NotFound,
});
